import { ExchangeCode } from "@/lib/market-data/market-data.types";

export interface AlertExchangeAvailability {
  binanceAvailable?: boolean | null;
  bybitAvailable?: boolean | null;
  gateAvailable?: boolean | null;
  kucoinAvailable?: boolean | null;
  hyperliquidAvailable?: boolean | null;
  asterdexAvailable?: boolean | null;
}

const ALERT_EXCHANGE_FLAGS: Array<{
  code: ExchangeCode;
  flag: keyof AlertExchangeAvailability;
}> = [
  { code: "binance", flag: "binanceAvailable" },
  { code: "bybit", flag: "bybitAvailable" },
  { code: "asterdex", flag: "asterdexAvailable" },
  { code: "hyperliquid", flag: "hyperliquidAvailable" },
  { code: "gate", flag: "gateAvailable" },
  { code: "kucoin", flag: "kucoinAvailable" },
];

/** Exchanges that already listed the token when the alert was created. */
export function listExchangesAvailableAtAlert(
  alert: AlertExchangeAvailability,
  preferred?: ExchangeCode
): ExchangeCode[] {
  const listed = ALERT_EXCHANGE_FLAGS.filter((entry) =>
    Boolean(alert[entry.flag])
  ).map((entry) => entry.code);

  if (preferred && listed.includes(preferred)) {
    return [preferred, ...listed.filter((code) => code !== preferred)];
  }
  return listed;
}

export function mapExchangeToSupportedCode(
  exchangeCode?: string | null
): ExchangeCode {
  const lower = (exchangeCode ?? "").toLowerCase();
  if (lower.includes("bybit")) return "bybit";
  if (lower.includes("gate")) return "gate";
  if (lower.includes("kucoin")) return "kucoin";
  if (lower.includes("hyperliquid")) return "hyperliquid";
  if (lower.includes("aster")) return "asterdex";
  return "binance";
}

